// extracted by mini-css-extract-plugin
export default {"social-share":"iejfLy","socialShare":"iejfLy"};